import React from 'react';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import CoursesSection from '../components/CoursesSection';
import BundlesSection from '../components/BundlesSection';
import PromoBanner from '../components/PromoBanner';
import SalePopup from '../components/SalePopup';
import SEO from '../components/SEO';
import { seoData } from '../data/seoData';

const CoursesPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <SEO {...seoData.courses} />
      <SalePopup />
      <PromoBanner />
      <Navigation />

      {/* Use the same CoursesSection component as Homepage */}
      <CoursesSection showLoadMore={false} showAllByDefault={true} />

      {/* Course Bundles */}
      <BundlesSection />
      
      <Footer />
    </div>
  );
};

export default CoursesPage;